import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { ContractorUserInterface } from '../interfaces/contractor-user.interface';
import { UserDto } from '../../user/dto/user.dto';
import { ContractorDto } from '../../contractor/dto/contractor.dto';

@Exclude()
export class ContractorUserDto
  extends CommonEntityDto
  implements ContractorUserInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated contractor ID',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiPropertyOptional({
    type: () => UserDto,
    title: 'User',
    description: 'The user associated with this contractor',
  })
  @Expose()
  user?: UserDto;

  @ApiPropertyOptional({
    type: () => ContractorDto,
    title: 'Contractor',
    description: 'The contractor associated with this user',
  })
  @Expose()
  contractor?: ContractorDto;
}
